// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.layout-error[data-v-518f19e9]{\n  display:-ms-flexbox;\n  display:flex;\n  height:100vh;\n  min-height:100vh;\n  -ms-flex-align:center;\n      align-items:center;\n  -ms-flex-pack:center;\n      justify-content:center;\n  background-color:#FFFFFF;\n  text-align:center\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
